// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as CatalogueCardList from "./CatalogueCardList.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function container(isSearch) {
  return Curry._1(BsCss.style, {
              hd: BsCss.paddingTop(BsCss.rem(1.5)),
              tl: {
                hd: BsCss.width(BsCss.pct(100.0)),
                tl: {
                  hd: BsCss.media("(max-width: 768px)", {
                        hd: BsCss.paddingTop(BsCss.rem(0.5)),
                        tl: /* [] */0
                      }),
                  tl: {
                    hd: BsCss.paddingBottom(BsCss.rem(isSearch ? 1.5 : 0.0)),
                    tl: /* [] */0
                  }
                }
              }
            });
}

var title = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.rem(1.5)),
      tl: {
        hd: BsCss.fontWeight({
              NAME: "num",
              VAL: 600
            }),
        tl: {
          hd: BsCss.paddingBottom(BsCss.rem(1.0)),
          tl: {
            hd: BsCss.media("(max-width: 480px)", {
                  hd: BsCss.fontSize(BsCss.rem(1.25)),
                  tl: {
                    hd: BsCss.paddingBottom(BsCss.rem(0.5)),
                    tl: /* [] */0
                  }
                }),
            tl: /* [] */0
          }
        }
      }
    });

var subTitle = Curry._1(BsCss.style, {
      hd: BsCss.maxWidth(BsCss.rem(56.0)),
      tl: /* [] */0
    });

var Styles = {
  container: container,
  title: title,
  subTitle: subTitle
};

var make = React.memo(function (props) {
      var isSearch = props.isSearch;
      var catalogue = props.catalogue;
      var isSearch$1 = isSearch !== undefined ? isSearch : false;
      var items = isSearch$1 ? Belt_Array.keep(catalogue, (function (s) {
                return s.slug === "prezzee-gift-card";
              })) : catalogue;
      if (items.length !== 0) {
        return JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("h2", {
                            children: isSearch$1 ? "Prezzee Smart eGift Cards" : "Co-branded gift options with endless choice",
                            className: title
                          }),
                      JsxRuntime.jsx("p", {
                            children: isSearch$1 ? "Your search has yielded no results. so why not consider the Prezzee Smart eGift Card which can be used to unlock our wall of retailer eGift Cards." : "A Smart eGift Card is the ultimate gift of choice for your business needs. One card, that can be co-branded with your company's logo, to be swapped for multiple eGift cards from hundreds of top brands.",
                            className: subTitle
                          }),
                      JsxRuntime.jsx(CatalogueCardList.make, {
                            catalogue: items,
                            skuDict: Caml_option.some(Belt_Option.getWithDefault(props.skuDict, {}))
                          })
                    ],
                    className: container(isSearch$1)
                  });
      } else {
        return null;
      }
    });

var SkuPresentation;

export {
  SkuPresentation ,
  Styles ,
  make ,
}
/* title Not a pure module */
